<template>
  <div class="mine_right flex_item">
    <div class="mine_rightTop hasTab">
      <div class="flex">
        <span class="mine_line"></span>
        <p class="flex_item">我的订单</p>
      </div>
      <div class="mine_tab flex">
        <a href="javascript:;" class="mine_tabItem" @click="updateSelectedTab('全部订单')"
          :class="tabItemClass('全部订单')">全部订单</a>
        <a href="javascript:;" class="mine_tabItem" @click="updateSelectedTab('待付款')"
          :class="tabItemClass('待付款')">待付款</a>
        <a href="javascript:;" class="mine_tabItem" @click="updateSelectedTab('支付成功')"
          :class="tabItemClass('支付成功')">支付成功</a>
        <a href="javascript:;" class="mine_tabItem" @click="updateSelectedTab('已关闭')"
          :class="tabItemClass('已关闭')">已关闭</a>
      </div>
    </div>
    <div class="mine_rightBody hasTab">
      <div class="kc_ul">
        <div v-for="(order, index) of orderList" :key="index" class="kc_li flex">
          <img :src = "order.cover" class="kc_tx" alt="" />
          <div class="kc_body flex_item">
            <div class="flex">
              <span class="kc_status" :class="statusMsgBgColorClass(order.orderStatus)">{{ order.orderStatus }}</span>
              <p class="kc_name flex_item">{{ order.courseName }}</p>
              <span class="order_money clo_org">￥{{ order.money }}</span>
            </div>
            <div class="flex oder_info">
              <div class="flex_item">
                <div class="order_detail">下单时间: {{ order.createTime }}</div>
                <div class="order_detail">订单号: {{ order.orderSn }}</div>
                <div class="order_detail" v-if='order.orderStatus == "支付成功"'>支付方式: {{ order.payType }}</div>
              </div>
              <div class="">
                <button class="kc_btn" @click="courseButtonAction(order)" >
                  {{ order.orderStatus }}
                </button>
                <button class="kc_btn" v-if='(order.orderStatus == "支付成功") && order.payType != "线下支付"' @click="openTkFc(order)">
                  申请退款
                </button>
                <!-- <span class="order_exp" v-if='order.orderStatus == "退款中"'>退款中</span> -->
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="orderList.length == 0" class="mine_rightBody hasTab">
      <div class="listNullTip">
        <img src="../../assets/icon_empty.png" />
        <span>暂无数据</span>
      </div>
    </div>
  </div>
  <div v-if="showOrderDetailLayer">
    <OrderDetailLayer @closeLayer="showOrderDetailLayer = false" :detail="orderDetail" />
  </div>
  <!-- 退款原因浮层start-->
  <div class="fc" v-if="tkFcStatus">
    <div class="fc_box">
      <div class="fc_top">
          <p class="fc_tit">取消原因<span class="clo_red">（订单取消后将无法恢复）</span></p>
          <img src="../../assets/close_fc.png" class="close" @click="tkFcStatus = false" alt="">
      </div>
      <div class="tk_box flex">
        <span :class="reasonId == item.id? 'tk_item active':'tk_item'" @click="changeReason(item.id,item.name)" v-for="(item, index) of remarkList">{{ item.name }}</span>
      </div>
      <div class="fc_fot">
        <span class="tk_item active" @click="refund()">提交</span>
        <span class="tk_item" @click="tkFcStatus = false">再想想</span>
      </div>
    </div>
  </div>
  <!-- 退款原因浮层end -->
</template>

<script>
import { getOrderList } from "../../server/user_center_order";
import { getOrderDetail } from "../../server/user_center_order_detail";
import { refund,getRemark } from "../../server/pay";
// 订单详情浮层
import OrderDetailLayer from "./MineOrderDetail"

export default {
  data() {
    return {
      orderList: [],
      selectedTab: "全部订单",
      showOrderDetailLayer: false,
      orderDetail: {},
      tkFcStatus: false,
      reasonId:0,
      orderSn:'',
      remark:'',
      remarkList:[]

    };
  },
  mounted() {
    this.fetchOrderList();
  },
  components: {
    OrderDetailLayer,
  },
  methods: {
    tabItemClass(tab) {
      return this.selectedTab == tab ? "active" : "";
    },
    updateSelectedTab(tab) {
      this.selectedTab = tab;
      this.fetchOrderList();
    },
    async fetchOrderList() {
      let params = {};
      switch (this.selectedTab) {
        case "待付款":
          params.orderStatus = 201;
          break;
        case "支付成功":
          params.orderStatus = 202;
          break;
        case "已关闭":
          params.orderStatus = 203;
          break;
        default:
          break;
      }
      let result = await getOrderList(params);
      if (result !== false) {
        this.orderList = result;
      }
    },
    statusMsgBgColorClass(status) {
      let cls = "";
      switch (status) {
        case "支付成功":
          cls = "back_green";
          break;

        default:
          cls = "back_org";
          break;
      }
      return cls;
    },
    async linkOrder(order) {
      console.log(order);
      this.$store.commit("updatePaymentOrderInfo", order);
      this.$router.push({
        name: 'Payment',
        query: {
          step: 2,
        }
      });
    },
    courseButtonAction(order) {
      switch (order.orderStatus) {
        case "待付款":
          // 跳转付款页面
          this.linkOrder(order);
          break;

        default:
          // 查看订单详情
          this.fetchOrderDetail(order.orderSn);
          break;
      }
    },
    async fetchOrderDetail(orderNumber) {
      let result = await getOrderDetail(orderNumber);
      console.log(result);
      if (result != false) {
        this.orderDetail = result;
        this.showOrderDetailLayer = true;
      }
    },
    //打开退款浮层
    async openTkFc(order){
      this.tkFcStatus = true
      this.reasonId = 0
      this.orderSn = order.orderSn
      //获取退款原因列表
      this.remarkList = await getRemark();
      console.log(this.remarkList);

    },
    //申请退款
    async refund(){
      if(!this.remark){
        alert('请选择退款原因')
        return false;
      }
      let params = {
        "remark": this.remark,
        "orderSn": this.orderSn
      }
      let result  = await refund(params);
      this.tkFcStatus = false
      this.fetchOrderList();
      console.log('refund',result);
    },
    //选择退款原因
    changeReason(id,cont){
      this.remark = cont
      this.reasonId = id
    }
  },
};
</script>

<style scoped>
.mine_right {
  box-sizing: border-box;
  margin-top: 16px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.mine_rightTop {
  padding: 24px 32px;
  border-bottom: 1px solid #f3f3f3;
  background-color: #fff;
}

.mine_rightTop p {
  font-size: 28px;
  font-weight: 600;
  color: #222;
}

.mine_rightTop.hasTab {
  border-bottom: 0px;
  padding-bottom: 0px;
}

.mine_line {
  width: 5px;
  height: 28px;
  background-color: #003399;
  border-radius: 3px;
  margin-right: 20px;
}

.mine_tab {
  margin-top: 40px;
}

.mine_tabItem {
  margin-right: 60px;
  font-size: 16px;
  color: #666;
  line-height: 22px;
  padding-bottom: 30px;
  font-weight: 500;
  position: relative;
}

.mine_tabItem.active {
  color: #222;
  font-weight: bold;
}

.mine_tabItem.active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  width: 36px;
  margin-left: -18px;
  height: 2px;
  background-color: #003399;
}

.mine_rightBody.hasTab {
  background-color: #f9f9f9;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
}

.kc_status {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  padding: 2px 8px;
  border-radius: 2px;
  background-color: #26ad8f;
  margin-right: 12px;
}

.kc_name {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
  margin-right: 20px;
}

.back_org {
  background-color: #ff8a15;
}

.back_green {
  background-color: #26ad8f;
}

.back_grey {
  background-color: grey;
}

.order_money {
  color: #222222;
  font-size: 18px;
  font-weight: 600;
}

.oder_info {
  margin-top: 5px;
}

.order_detail {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 20px;
}

.clo_org {
  color: #ff6100 !important;
}

.kc_btn {
  font-size: 14px;
  color: #003399;
  font-weight: 400;
  width: 90px;
  background-color: white;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border: 1px solid #003399;
  border-radius: 4px;
  margin-top: -10px;
  cursor: pointer;
  display: block;
  margin-top: 10px;
}

.kc_li {
  margin-top: 16px;
  padding: 24px;
  background-color: #fff;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.kc_tx {
  width: 176px;
  height: 120px;
  margin-right: 20px;
}

.listNullTip {
  width: 100%;
  padding-top: 126px;
}

.listNullTip img {
  display: block;
  margin: 0 auto;
  width: 240px;
  margin-bottom: 9px;
}

.listNullTip span {
  display: block;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
}
.clo_red{
  color: red;
}
.fc_tit .clo_red{
  font-size: 14px;
}
.tk_box{
  flex-wrap: wrap;padding-bottom: 40px;padding-top: 15px;
}
.tk_item{
  display: inline-block;padding: 5px 15px;border-radius: 15px;border: 1px solid #ccc;margin-top: 15px;margin-right: 10px;cursor:pointer;
}
.tk_item.active{
  color: #003399;border-color: #003399;
}
.fc_box{
  height: unset;
}
.fc_fot{
  padding: 10px 0px;
}
.fc_fot .tk_item{
  font-size: 14px;
}
.fc_fot .tk_item.active{
  background-color: #003399;color: #fff;
}
</style>